var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"col-md-6"},[_c('button',{staticClass:"badge btn-success btn-xs"},[(_vm.idproofurl!=null)?_c('a',{staticStyle:{"color":"white"},attrs:{"href":_vm.idproofurl,"target":"_blank"}},[_vm._v("View")]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }